import React from 'react';

export interface LinkProps {
    linkComponent?: React.ElementType<any>;
    href?: string;
    text?: string;
    transformLinkProps?: (defaultProps: { href: string }) => { [key: string]: any };
}

interface LinkWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    link: LinkProps;
    children?: React.ReactNode;
    disabled?: boolean;
}

export const LinkWrapper = ({ link, children, className, disabled = false, ...props }: LinkWrapperProps) => {
    const LinkWrapper = link?.linkComponent || 'a';
    // Use transformLinkProps to customize the link props or default to given href
    const linkProps = link?.transformLinkProps ? link.transformLinkProps({ href: link.href }) : { href: link?.href };

    const content = children || link?.text;
    return (
        <LinkWrapper {...linkProps} className={className} {...props}>
            {content}
        </LinkWrapper>
    );
};
